import { render, staticRenderFns } from "./ProductCompliance.vue?vue&type=template&id=876a8376&scoped=true&"
import script from "./ProductCompliance.vue?vue&type=script&lang=js&"
export * from "./ProductCompliance.vue?vue&type=script&lang=js&"
import style0 from "./ProductCompliance.vue?vue&type=style&index=0&id=876a8376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876a8376",
  null
  
)

export default component.exports